export default __webpack_public_path__ + "5228f35.png";